import { render, staticRenderFns } from "./exercises-wrong-exercises.vue?vue&type=template&id=371b3a60"
import script from "./exercises-wrong-exercises.vue?vue&type=script&lang=js"
export * from "./exercises-wrong-exercises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports